import { Bot, PenLine, Type, Newspaper, Megaphone, Globe, Edit3, ClipboardList, Sparkles, FileSearch } from "lucide-react";

// 도구 그룹별 아이콘(2026-07-18 피드백 — "작은 아이콘으로 힌트를") — 색(차트 라인 컬러)과
// 모양(아이콘)의 이중 부호화. 색만으로는 10개 그룹을 구분하기 어려운데, 모양이 더해지면
// 표 헤더·필터에서 그룹을 읽지 않고도 식별할 수 있다.
export const SUPER_GROUP_ICONS = {
  buddy: Bot,                 // 버디 — 대화 상대
  proofread: PenLine,         // 교열 — 교정 펜
  title: Type,                // 제목 — 활자
  print: Newspaper,           // 지면 — 신문
  press: Megaphone,           // 보도자료 — 알림
  foreign: Globe,             // 외신 — 지구본
  column: Edit3,              // 퇴고 — 고쳐쓰기
  assist: ClipboardList,      // 맞춤지시·기사진단 — 점검 목록
  freeform: Sparkles,         // 자유대화·이미지생성 — 생성
  style_analysis: FileSearch, // 문체 분석 — 문서 탐색
};

export function GroupIcon({ superGroup, color, className = "h-3.5 w-3.5" }) {
  const Icon = SUPER_GROUP_ICONS[superGroup];
  if (!Icon) return null;
  return <Icon className={`shrink-0 ${className}`} style={color ? { color } : undefined} />;
}
